export default {
  app: {
    locale: 'fr-ch',
    languages: [
      { key: 'en-ch', name: 'English', shortName: 'En' },
      { key: 'fr-ch', name: 'Français', shortName: 'Fr' },
      { key: 'de-ch', name: 'Deutsch', shortName: 'De' },
      { key: 'it-ch', name: 'Italiano', shortName: 'It' }
    ],
    countriesCodes: ['de', 'ch', 'fr', 'it'],
    passwordSecurity: { level: 'medium', minLength: 8 },
    sections: {
      createAccount: false,
      dashboard: true,
      inbox: false,
      login: true,
      markets: false,
      mfa: true,
      onboarding: true,
      planner: false,
      portfolios: [],
      profile: ['me', 'investor', 'documents', 'legal', 'portfolios', 'privacy', 'security', 'about'],
      reports: true,
      resetPassword: true,
      selfTrading: false,
      transfers: true,
      watchlist: false
    }
  },
  api: {
    host: process.env.VUE_APP_API_HOST,
    timeout: 300000
  },
  brand: {
    name: 'Opsion',
    nameAttached: 'Fondation Libre Passage',
    nameLegal: 'Groupe Mutuel',
    shortName: 'Opsion',
    address: 'Passage Saint-Antoine 7, 1800 Vevey (Suisse)',
    phone: '+41 (0) 583 204 031'
  },
  provider: {
    supportEmail: process.env.VUE_APP_PROVIDER_SUPPORT,
    supportPhone: process.env.VUE_APP_PROVIDER_SUPPORT_PHONE
  },
  portfolio: {
    adviceEngine: 'model_portfolio',
    advisorGroup: 'opsion',
    defaultType: 'LP',
    initialAmount: 100000,
    maximumInitialAmount: 10000000,
    showPerformance: false,
    timeHorizonDefault: 25
  },
  withdrawals: {
    types: ['full']
  },
  allocation: {
    stackedChart: 'assetClasses',
    donutChart: 'assetCategories',
    tablePositionList: 'assetClasses',
    assetClassHierarchy: [
      'CASH',
      'MONEY_MARKET',
      'BONDS',
      'ALTERNATIVE_INVESTMENTS',
      'MULTI_ASSETS',
      'EQUITIES',
      'REAL_ESTATE',
      'UNDEFINED'
    ],
    avatar: false,
    assetDetail: false,
    priceVariation: false
  },
  documents: {
    host: process.env.VUE_APP_DOCUMENT_HOST,
    legalDocumentBeneficiary: '/documents/beneficiaire__LANG_.pdf',
    legalDocumentFees: '/documents/fees__LANG_.pdf',
    legalDocumentInvestmentRegulations: '/documents/investment_regulations__LANG_.pdf',
    legalDocumentPensionFundRegulations: '/documents/pension_fund_regulations__LANG_.pdf',
    // eslint-disable-next-line max-len
    privacyPolicy: `${process.env.VUE_APP_DOCUMENT_HOST_PUBLIC}/Politique_Confidentialite_Fondation_Opsion_Libre_Passage-_LANG_.pdf`,
    termsAndConditions: `${process.env.VUE_APP_DOCUMENT_HOST_PUBLIC}/TandC_OpsionVestedBenefitsFoundation-_LANG_.pdf`,
    transferForm: '', // get it from the API
    userContract: '' // get it from the API
  }
}
